exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2DvDxpGW_nkgsKxSnz-X5k{position:fixed;pointer-events:\"none\";z-index:1000;top:0;font-size:12px;font-weight:400}html[dir] ._2DvDxpGW_nkgsKxSnz-X5k{border-width:1px;border-style:solid;padding:0 4px;background:\"[theme:neutralTertiary, default:#a6a6a6]\"}html[dir=ltr] ._2DvDxpGW_nkgsKxSnz-X5k{left:0}html[dir=rtl] ._2DvDxpGW_nkgsKxSnz-X5k{right:0}._3UTpE2e0T_Tv_HSCVg1XSZ,._25lsyorNBt3xkuy2HCH0lv{color:\"[theme:themeDark, default:#0D62AA]\";font-weight:600}html[dir] ._3UTpE2e0T_Tv_HSCVg1XSZ{background-color:\"[theme:themeLighter, default:#DEECF9]\";border-radius:2px;padding:2px 6px}html[dir=ltr] ._3UTpE2e0T_Tv_HSCVg1XSZ{margin-right:-6px}html[dir=rtl] ._3UTpE2e0T_Tv_HSCVg1XSZ{margin-left:-6px}._2M0rDr9a97qwKxdsizNHUn{-webkit-animation-duration:.666s;animation-duration:.666s}", ""]);

// exports
exports.locals = {
	"dragPreview": "_2DvDxpGW_nkgsKxSnz-X5k",
	"unreadCount": "_25lsyorNBt3xkuy2HCH0lv",
	"newCount": "_3UTpE2e0T_Tv_HSCVg1XSZ",
	"addedNode": "_2M0rDr9a97qwKxdsizNHUn"
};